import React, { useEffect, useState, Fragment } from 'react';
import { Link, useLocation } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import Multiselect from 'multiselect-react-dropdown';
import PropTypes from "prop-types";
import CardHeader from 'components/PurpleTheme/CardHeader';
import {
  Badge,
  Card,
  Col,
  Collapse,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  CardBody,
  Table,
  PopoverBody,
  Popover,
  UncontrolledTooltip,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {getAlertLogs, postAcknowledgeAlert, postResolveAlert, selectAlert, getNotificationChannels as onGetNotificationChannels, getServices as onGetServices, getUsers as onGetUsers, getAlertLogsCount, getIntegrationTypes as onGetIntegrationTypes,} from 'store/actions'
import { getIntegrationLogo, getLocalDateTime, getUserColor } from "../../helpers/component_helpers";
import InitialsAvatar from "../Profile/InitialsAvatar";
import { showNotification } from 'components/Common/notification';
import profileImg from "../../assets/images/profile.png";
import './alert-log.scss'

const AlertList = ({ NumberOfItemsPerPage }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const applicationServiceId = queryParams.get('serviceId');
  const { alerts } = useSelector(state => ({ alerts: state.AlertLog.alerts }));
  const integrationTypes  = useSelector(state => (state.AlertLog.integration_types));
  const { alerts_log_count } = useSelector(state => ({ alerts_log_count: state.AlertLog.alerts_log_count }));
  const { services } = useSelector(state => ({
    services: state.Service.services
  }));
  const { users } = useSelector(state => ({
    users: state.Organization.users
  }));
  let { current_notification_channels } = useSelector(state => ({
    current_notification_channels: state.Dashboard.notification_channels || []
  }));
  const dispatch = useDispatch();
  const itemsPerPage = NumberOfItemsPerPage || 100;
  const total_resources = alerts_log_count?.alertlog_count || 0;
  const [selectedPage, setSelectedPage] = useState(1);
  const [alertData, setAlertData] = useState(alerts || []);
  const [search, setSearch] = useState("");
  const [userColors, setUserColors] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchService, setSearchService] = useState([]);
  const [searchUser, setSearchUser] = useState([]);
  const [searchSource,setSearchSource] = useState([]);
  const [searchStatus, setSearchStatus] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [checkBox, setCheckBox] = useState({});
  const [allCheckBox, setAllCheckBox] = useState(false);
  const [filteredAlerts, setFilteredAlerts] = useState(alerts || {});
  const [popoverOpen, setPopoverOpen] = useState({});
  const [popoverOpen2, setPopoverOpen2] = useState({});
  const [popoverOpen3, setPopoverOpen3] = useState({});
  const [popoverOpen4, setPopoverOpen4] = useState({});
  const [alert_list, setAlertList] = useState([]);

  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const toggle = () => {
    setIsOpen(!isOpen);
  }

  const headers = ['Alert Name', 'Source', 'Application', 'Resource Name', 'Metric', 'Status', 'Assigned To', 'Opened At', 'Closed At'];

  const searchParams = new URLSearchParams(location.hash.substring(1));
  const searchQuery = searchParams.get("integration_type");
  const integration_type = searchQuery ? searchQuery : null;

  useEffect(() => {
    if (applicationServiceId) {
      let payload = {
        'page': 1,
        'limit': itemsPerPage,
        'application_service_ids': [applicationServiceId],
        'integration_type': integration_type,
      }
      dispatch(getAlertLogs(payload));
    }
    else {
      let payload = {
        'page': 1,
        'limit': itemsPerPage,
        'integration_type': integration_type,
      }
      dispatch(getAlertLogs(payload));
    }
  }, [getAlertLogs, applicationServiceId]);

  useEffect(() => {
    if (applicationServiceId) {
      let payload = {
        'page': 1,
        'limit': itemsPerPage,
        'application_service_ids': [applicationServiceId],
        'integration_type': integration_type,
      }
      dispatch(getAlertLogsCount(payload));
    }
    else {
      let payload = {
        'page': 1,
        'limit': itemsPerPage,
        'integration_type': integration_type,
      }
      dispatch(getAlertLogsCount(payload));
    }
  }, [getAlertLogsCount, applicationServiceId]);

  useEffect(() => {
    dispatch(onGetIntegrationTypes());
  },[dispatch])


  const totalPages = Math.ceil(total_resources / itemsPerPage);
  let startPage = Math.max(selectedPage - 1, 1);
  let endPage = Math.min(startPage + 2, totalPages);
  if (endPage === totalPages) {
    startPage = Math.max(totalPages - 2, 1);
  }
  const resourceCount = Object.keys(filteredAlerts).length;

  useEffect(() => {
    let userColorsMap = [];
    alerts.map((alert, index) => {
      if (alert.assigned_to) {
        let userColor = {};
        userColor = {
          id: alert.assigned_to.id,
          name: alert.assigned_to.name,
          color: getUserColor(alert.assigned_to.email),
        }
        userColorsMap.push(userColor);
      }
    });
    setUserColors(userColorsMap);
    setAlertData(alerts);
    setFilteredAlerts(alerts);
    setIsLoading(false);
  }, [alerts]);

  useEffect(() => {
    dispatch(onGetNotificationChannels());
  }, [onGetNotificationChannels]);

  useEffect(() => {
    dispatch(onGetUsers());
  }, [onGetUsers]);

  useEffect(() => {
    dispatch(onGetServices());
  }, [onGetServices]);

  useEffect(() => {
    handleSearch(search);
  }, [search]);

  const handlePageClick = (pageNumber) => {
    setIsLoading(true);

    if (pageNumber < 1) {
      setIsLoading(false);
      return;
    }

    if (selectedPage < pageNumber && alertData.length < itemsPerPage) {
      setIsLoading(false);
      return;
    }

    setSelectedPage(pageNumber);

    let pageFilters = {}

    let application_service_ids = []
    let status_list = []
    let assigned_to = []
    let integration_types = []

    if (applicationServiceId) {
      application_service_ids.push(applicationServiceId);
      pageFilters['application_service_ids'] = application_service_ids;
    }

    current_notification_channels.map((notification_channel) => {
      if (notification_channel.is_primary === true) {
        if (notification_channel.name === "Email") {
          searchService.map((service) => {
            application_service_ids.push(service.value);
          })
          pageFilters['application_service_ids'] = application_service_ids;
        }
      }
    });

    current_notification_channels.map((notification_channel) => {
      if (notification_channel.is_primary === true) {
        if (notification_channel.name === "Email") {
          searchUser.map((user) => {
            assigned_to.push(user.value);
          })
          pageFilters['assigned_to'] = assigned_to;
        }
      }
    });

    current_notification_channels.map((notification_channel) => {
      if (notification_channel.is_primary === true) {
        if (notification_channel.name === "Email") {
          searchStatus.map((status) => {
            status_list.push(status.key);
          })
          pageFilters['status_list'] = status_list;
        }
      }
    });

    current_notification_channels.map((notification_channel) => {
      if (notification_channel.is_primary === true) {
        if (notification_channel.name === "Email") {
          searchSource.map((source) => {
            integration_types.push(source.value);
          })
          pageFilters['source_types'] = integration_types;
        }
      }
    });

    const formattedStartDate = startDate ? formatDate(startDate) : '';
    const formattedEndDate = endDate ? formatDate(endDate) : '';

    pageFilters['page'] = pageNumber;
    pageFilters['limit'] = itemsPerPage;
    pageFilters['search_item'] = search;
    pageFilters['start_date'] = formattedStartDate;
    pageFilters['end_date'] = formattedEndDate;
    pageFilters['integration_type'] = integration_type;
    dispatch(getAlertLogs(pageFilters));
    dispatch(getAlertLogsCount(pageFilters));
    setSelectedPage(pageNumber);
  };

  const handleSearch = (searchTerm) => {
    setCheckBox({});
    setAllCheckBox(false);
    let filtered = alertData.filter(alert => {
      return alert.name.toLowerCase().includes(searchTerm.toLowerCase());
    });
    setFilteredAlerts(filtered);
  }

  const handleCheckBox = (key) => {
    let checkBoxObj = {};
    Object?.assign(checkBoxObj, checkBox);
    if (checkBoxObj[key] === true) {
      delete checkBoxObj[key];
    } else {
      checkBoxObj[key] = true
    }
    setCheckBox(checkBoxObj);
    setAllCheckBox(false);
  };

  useEffect(() => {
    const temp_state = Object.keys(checkBox);
    const selected_alerts = alerts?.filter(alert => temp_state.includes(alert.id));
    setAlertList(prevAlertList => {
      return [
        ...prevAlertList.filter(alert => !temp_state.includes(alert.id)),
        ...selected_alerts
      ];
    });
  }, [checkBox, alerts]);

  function availableIntegrationTypes(integrationTypes){
    if(integrationTypes && integrationTypes.length > 0){
      return integrationTypes.map((type) => ({
        label: type,
        value: type
      }));
    }
  }

  const handAllCheckBox = () => {
    let checkBoxObj = {}
    if (allCheckBox === true) {
      filteredAlerts?.map((item, index) => {
        delete checkBoxObj[item.id];
      })
      setCheckBox({});
      setAllCheckBox(false);
    } else {
      filteredAlerts?.map((item, index) => {
        checkBoxObj[item.id] = true
      })
      setCheckBox(checkBoxObj);
      setAllCheckBox(true);
    }
  };

  const handleSelect = (selectedItem) => {
    dispatch(selectAlert(selectedItem));
  }

  const handleAcknowledgeAlerts = () => {
    let selectedAlertIds = [];
    for (let key in checkBox) {
      selectedAlertIds.push(key);
    }
    let payload = {
      'alert_ids': selectedAlertIds
    }
    dispatch(postAcknowledgeAlert(payload));
  }

  const handleResolveAlerts = () => {
    let selectedAlertIds = [];
    for (let key in checkBox) {
      selectedAlertIds.push(key);
    }
    let payload = {
      'alert_ids': selectedAlertIds
    }
    dispatch(postResolveAlert(payload));
  }

  const filterByServiceType = (selectedList, selectedItem) => {
    setSearchService(selectedList);
  }
  const unfilterByServiceType = (selectedList, removedItem) => {
    setSearchService(selectedList);
  }

  const filterByUserType = (selectedList, selectedItem) => {
    setSearchUser(selectedList);
  }
  const unfilterByUserType = (selectedList, removedItem) => {
    setSearchUser(selectedList);
  }

  const filterBySourceType = (selectedList, selectedItem) => {
    setSearchSource(selectedList);
  }
  const unfilterBySourceType = (selectedList, removedItem) => {
    setSearchSource(selectedList);
  }

  const filterByStatusType = (selectedList, selectedItem) => {
    setSearchStatus(selectedList);
  }
  const unfilterByStatusType = (selectedList, removedItem) => {
    setSearchStatus(selectedList);
  }

  const handleStartDateChange = (event) => {
    const dateValue = event.target.value;
    setStartDate(dateValue ? new Date(dateValue) : null);
  };

  const handleEndDateChange = (event) => {
    const dateValue = event.target.value;
    const newEndDate = dateValue ? new Date(dateValue) : null;
    if (startDate && newEndDate && newEndDate < startDate) {
      showNotification("error", "End date cannot be before the start date")
      return;
    }
    setEndDate(newEndDate);
  };

  const togglePopover = (key, isOpen) => {
    setPopoverOpen(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const togglePopoverService = (key, isOpen) => {
    setPopoverOpen2(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const togglePopoverMetric = (key, isOpen) => {
    setPopoverOpen4(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const togglePopoverResource = (key, isOpen) => {
    setPopoverOpen3(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const handleMouseEnter = (key) => {
    togglePopover(key, true);
  };

  const handleMouseEnterService = (key) => {
    togglePopoverService(key, true);
  };

  const handleMouseEnterResource = (key) => {
    togglePopoverResource(key, true);
  };

  const handleMouseEnterMetric = (key) => {
    togglePopoverMetric(key, true);
  };

  const handleMouseLeave = (key) => {
    togglePopover(key, false);
  };

  const handleMouseLeaveService = (key) => {
    togglePopoverService(key, false);
  };

  const handleMouseLeaveMetric = (key) => {
    togglePopoverMetric(key, false);
  };

  const handleMouseLeaveResource = (key) => {
    togglePopoverResource(key, false);
  };

  function getFilter() {
    let serviceOptions = [];
    services.map((service) => {
      serviceOptions.push({ value: service.id, label: service.name });
    });
    for (let notification_channel of current_notification_channels) {
      if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
        return (<Multiselect name="service_option"
          placeholder="Filter: Service"
          options={serviceOptions}
          displayValue="label"
          closeOnSelect={true}
          onSelect={filterByServiceType}
          onRemove={unfilterByServiceType}
          style={{optionContainer:{backgroundColor: "#382b42"}}}
           />)
      }
    }
    return (<Fragment />)
  }

  function getStatus() {
    let statusOptions = [
      { key: 'Ok', label: 'OK' },
      { key: 'Alarm', label: 'Alarm' },
      { key: 'Acknowledged', label: 'Acknowledged' },
      { key: 'Insufficient Data', label: 'Insufficient Data' },
    ];
    for (let notification_channel of current_notification_channels) {
      if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
        return (<Multiselect name="status_option"
          placeholder="Filter: Status"
          options={statusOptions}
          displayValue="label"
          closeOnSelect={true}
          onSelect={filterByStatusType}
          onRemove={unfilterByStatusType}
          style={{optionContainer:{backgroundColor: "#382b42"}}}
          />)
      }
    }
    return (<Fragment />)
  }

  function getUsers() {
    let userOptions = [];
    users.map((user) => {
      userOptions.push({ value: user.id, label: user.name });
    });
    for (let notification_channel of current_notification_channels) {
      if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
        return (<Multiselect name="user_option"
          placeholder="Filter: Assigned to User"
          options={userOptions}
          displayValue="label"
          closeOnSelect={true}
          onSelect={filterByUserType}
          onRemove={unfilterByUserType}
          style={{optionContainer:{backgroundColor: "#382b42"}}}
          />)
      }
    }
    return (<Fragment />)
  }

    const useViewport = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleWindowResize);

      return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { width };
  };
  const { width } = useViewport();
  const breakpoint = 430;

  function getSource() {
    for (let notification_channel of current_notification_channels) {
      if (notification_channel.name === "Email" && notification_channel.is_primary === true) {
        return (
            <Multiselect
                name="source_option"
                placeholder="Filter: Source"
                options={availableIntegrationTypes(integrationTypes)}
                displayValue="label"
                closeOnSelect={true}
                onSelect={filterBySourceType}
                onRemove={unfilterBySourceType}
                style={{ optionContainer: { backgroundColor: "#382b42" } }}
            />
        );
      }
    }

    return (<Fragment />);
  }

  const checkboxColStyle = {
    width: '10%',
    textAlign: 'center',
    minWidth: '3rem'
  };

  const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '0.5rem',

  };

  const nameColStyle = {
    width: '40%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  };

  const statusColStyle = {
    width: '25%',
    textAlign: 'center'
  };

  const dateColStyle = {
    width: '25%',
    textAlign: 'center'
  };

  const linkStyle = {
    textDecoration: 'none',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
  const MobileComponent = () =>
  {
    return (
        <>
          <div>
            <div className="d-inline-flex d-md-flex align-items-center padding-t-10 bg-transparent">
              <Col md="3" className='bg-transparent pt-2 pt-md-0'>
                <div className="mb-2 text-center ms-2 pe-2 pe-md-0 ps-1 ps-md-0 ms-md-0 me-4 me-md-0">
                  {
                    allCheckBox ?
                        <i className="bx bx-check-square bx-sm"
                           onMouseOver={() => handAllCheckBox()}></i>
                        :
                        <i className="bx bx-square bx-sm" onMouseOver={() => handAllCheckBox()}></i>
                  }
                </div>
              </Col>
              <Col md="2">
                <div className="text-center me-5 me-md-0 me-lg-5">
                  {"Alert Name"}
                </div>
              </Col>
              <Col md="1">
                <div className="text-center me-5 me-md-0 me-lg-2 ms-1 ms-md-0">
                  {"Status"}
                </div>
              </Col>
              <Col md="1">
                <div className="text-center">
                  {"Opened At"}
                </div>
              </Col>
            </div>
          </div>
          <div>
            {filteredAlerts?.map((item) => (
                <div
                    key={item?.id}
                    style={{
                      marginBottom: '1rem',
                      background: 'transparent',
                      border: 'none',
                      boxShadow: 'none'
                    }}
                >
                  <div style={{padding: '0.5rem 0'}}>
                    <div style={rowStyle}>
                      {/* Checkbox */}
                      <div style={checkboxColStyle}>
                        {checkBox[item.id] ? (
                            <i
                                className="bx bx-check-square bx-sm"
                                onMouseOver={() => handleCheckBox(item.id)}
                                style={{cursor: 'pointer'}}
                            ></i>
                        ) : (
                            <i
                                className="bx bx-square bx-sm"
                                // onClick={() =>
                                onMouseOver={() => handleCheckBox(item.id)}
                                style={{cursor: 'pointer'}}
                            ></i>
                        )}
                      </div>

                      {/* Alert Name */}
                      <div style={nameColStyle}>
                        <Link
                            id={`alertlog-link-${item?.id}`}
                            to={`/alert-log/${item.id}`}
                            style={linkStyle}
                            onMouseEnter={() => handleMouseEnter(item.id)}
                            onMouseLeave={() => handleMouseLeave(item.id)}
                        >
                          {item?.name}
                        </Link>
                        <Popover
                            isOpen={popoverOpen[item.id] || false}
                            target={`alertlog-link-${item?.id}`}
                            placement="top"
                        >
                          <PopoverBody>{item.name}</PopoverBody>
                        </Popover>
                      </div>

                      {/* Status */}
                      <div style={statusColStyle}>
                        <Badge
                            style={{fontSize: '0.8rem'}}
                            color={
                              item.status === "Alarm"
                                  ? "danger"
                                  : item.status === "Ok"
                                      ? "success"
                                      : "warning"
                            }
                        >
                          {item.status === "Acknowledged" ? "Acked" : item.status === "Ok" ? "Resolved" : item.status}

                        </Badge>
                      </div>

                      {/* Date */}
                      <div style={dateColStyle}>
                        {getLocalDateTime(item.opened_at)}
                      </div>
                    </div>
                  </div>
                </div>
            ))}
          </div>
        </>
    );
  }

  return width < breakpoint ? (
      <div className="d-block">
          <div className={"ml-auto px-2 ms-1 ms-md-0 mt-1 mt-md-0 mb-md-1 custom-width"}>
            <div className="d-inline-flex custom-width">
              <div className="me-2 w-50">
                <Col md="auto">
                  <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={() => {
                        handleAcknowledgeAlerts();
                      }}
                      disabled={Object.values(checkBox).length === 0 || filteredAlerts.some(item => checkBox[item?.id] && (item?.status === 'Ok' || item?.status === 'Acknowledged'))}
                  >
                    Acknowledge
                  </button>
                </Col>
              </div>

              <div className="me-2 w-50">
                <Col md="auto">
                  <button
                      type="button"
                      className="btn btn-primary w-100 "
                      onClick={() => {
                        handleResolveAlerts();
                      }}
                      disabled={Object.values(checkBox).length === 0 || filteredAlerts.some(item => checkBox[item?.id] && item?.status === 'Ok')}
                  >
                    Resolve
                  </button>
                </Col>
              </div>
            </div>
          </div>
          <div>
            <MobileComponent/>
          </div>

      </div>
 )
 :
  (
      <React.Fragment>
        <div className="d-flex align-items-center justify-content-start flex-wrap mb-3">
          <div className="me-5 me-md-2 col-3 mb-1 py-1 py-md-0 custom-width">
            <Col md="11">
              <input
                  name="search"
                  className="searchbar"
                  placeholder="Search: Name"
                  type="string"
                  onChange={e => {
                    setSearch(e.target.value);
                  }}
              />
            </Col>
          </div>
          <div className="me-2 mb-1 d-none d-md-flex">
            <Col md="auto">
              <a href="#" onClick={toggle} className="btn btn-secondary">
                <i className="bx bx-filter-alt align-middle"></i> Advanced Filter
              </a>
            </Col>
          </div>
          <div className={"ml-auto px-2 ms-1 ms-md-0 mt-1 mt-md-0 mb-md-1 custom-width"}>
            <div className="d-inline-flex custom-width">
              <div className="me-2 w-50">
                <Col md="auto">
                  <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={() => {
                        handleAcknowledgeAlerts();
                      }}
                      disabled={Object.values(checkBox).length === 0 || filteredAlerts.some(item => checkBox[item?.id] && (item?.status === 'Ok' || item?.status === 'Acknowledged'))}
                  >
                    Acknowledge
                  </button>
                </Col>
              </div>

              <div className="me-2 w-50">
                <Col md="auto">
                  <button
                      type="button"
                      className="btn btn-primary w-100 "
                      onClick={() => {
                        handleResolveAlerts();
                      }}
                      disabled={Object.values(checkBox).length === 0 || filteredAlerts.some(item => checkBox[item?.id] && item?.status === 'Ok')}
                  >
                    Resolve
                  </button>
                </Col>
              </div>
              <div className="me-2 d-none d-md-inline-flex">
                <Col md="auto">
                  <Link className="btn btn-success" to="/rca-form" state={{alert_list: alert_list}}>
                    Create RCA
                  </Link>
                </Col>
              </div>
              {/*<div className="me-2">*/}
              {/*  <Col md="auto">*/}
              {/*    <Link className="btn btn-success" to="/create-incident" state={{alert_list: alert_list}}>*/}
              {/*      Create Incident*/}
              {/*    </Link>*/}
              {/*  </Col>*/}
              {/*</div>*/}
            </div>
          </div>
          <div className="ms-auto d-none d-md-flex">
            <Col md="auto">
              <Pagination aria-label="pagination navigation"
                          listClassName="pagination-rounded-new mb-0">
                {totalPages > 1 && (<PaginationItem key={Math.max(selectedPage - 1, 1)} disabled={selectedPage === 1}>
                  <PaginationLink
                      href=""
                      onClick={() => handlePageClick(Math.max(selectedPage - 1, 1))}
                  >
                    <i className="mdi mdi-chevron-left"/>
                  </PaginationLink>
                </PaginationItem>)}
                {[...Array(endPage - startPage + 1)].map((_, index) => (
                    <PaginationItem key={startPage + index} active={selectedPage === startPage + index}>
                      <PaginationLink href="" onClick={() => handlePageClick(startPage + index)}>
                        {startPage + index}
                      </PaginationLink>
                    </PaginationItem>
                ))}
                {totalPages > 1 && (
                    <PaginationItem key={Math.min(selectedPage + 1, totalPages)} disabled={selectedPage === totalPages}>
                      <PaginationLink
                          href=""
                          onClick={() => handlePageClick(Math.min(selectedPage + 1, totalPages))}
                      >
                        <i className="mdi mdi-chevron-right"/>
                      </PaginationLink>
                    </PaginationItem>)}
              </Pagination>
            </Col>
          </div>
        </div>

        <Collapse isOpen={isOpen} id="filterCollapse">
          <Row>
            <Row className="mb-3">
              <Col md={3} lg={3}>{getFilter()}</Col>
              <Col md={3} lg={3}>{getStatus()}</Col>
              <Col md={3} lg={3}>{getUsers()}</Col>
              <Col md={3} lg={3}>{getSource()}</Col>
            </Row>
            <Row className="mb-3">
              <Col style={{fontWeight: "500"}} md={2} lg={2}>
                Alert Opened between
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={2} lg={2}>
                <label
                    htmlFor="start-date-input"
                    className="col-md-12 col-form-label"
                >
                  Start Date:
                </label>
              </Col>
              <Col md={3} lg={3}>
                <input
                    className="form-control text-white bg-transparent border border-white"
                    type="date"
                    placeholder='Start Date'
                    id="start-date-input"
                    value={startDate ? startDate.toISOString().split('T')[0] : ''}
                    onChange={handleStartDateChange}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col md={2} lg={2}>
                <label
                    htmlFor="start-date-input"
                    className="col-md-12 col-form-label"
                >
                  End Date:
                </label>
              </Col>
              <Col md={3} lg={3}>
                <input
                    className="form-control text-white bg-transparent border border-white"
                    type="date"
                    placeholder='End Date'
                    id="end-date-input"
                    value={endDate ? endDate.toISOString().split('T')[0] : ''}
                    onChange={handleEndDateChange}
                />
              </Col>
            </Row>
            <Col md={2} lg={2}>
              <div className="mb-3">
                <button type="button" className="btn btn-primary w-md" onClick={() => handlePageClick(1)}>
                  Submit
                </button>
              </div>
            </Col>
          </Row>
        </Collapse>

        <CardHeader>
          <div className="d-inline-flex d-md-flex align-items-center padding-t-10 bg-transparent">
            <Col md="1" className='bg-transparent pt-2 pt-md-0'>
              <div className="mb-2 text-center me-1 me-md-0">
                {
                  allCheckBox ?
                    <i className="bx bx-check-square bx-sm" onClick={() => handAllCheckBox()}></i>
                    :
                    <i className="bx bx-square bx-sm" onClick={() => handAllCheckBox()}></i>
                }
              </div>
            </Col>
            <Col md="2">
              <div className="text-center me-5 me-md-0 me-lg-5">
                {"Alert Name"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center d-none d-md-block">
                {"Source"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center d-none d-md-block">
                {"Application"}
              </div>
            </Col>
            <Col md="2">
              <div className="text-center d-none d-md-block">
                {"Resource"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center d-none d-md-block">
                {"Metric"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center me-5 me-md-0 me-lg-2">
                {"Status"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center d-none d-md-block">
                {"Assigned To"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center">
                {"Opened At"}
              </div>
            </Col>
            <Col md="1">
              <div className="text-center d-none d-md-block">
                {"Closed At"}
              </div>
            </Col>
          </div>
        </CardHeader>

      <div className="scrollable-container-transparent">
        {filteredAlerts?.map((item, index) => (
          <CardHeader key={item.id} className={(checkBox[item.id] ? 'card-border' : '')}>
            <CardBody>
              <div className="d-inline-flex d-md-flex align-items-center ">
                <Col xs="1" md="1" className="padding-t-10 text-center custom-width-checkbox">
                  {checkBox[item.id] === true ? (
                      <i
                        className="bx bx-check-square bx-sm"
                        onClick={() => handleCheckBox(item.id)}
                      ></i>
                    ) : (
                      <i
                        className="bx bx-square bx-sm"
                        onClick={() => handleCheckBox(item.id)}
                      ></i>
                    )}
                </Col>
                <Col xs="5" md='2' className="padding-t-10 align-items-start col-sm" >
                  <div className="ms-2 ms-md-0 custom-wrap custom-width-alert-name">
                    <h6 className="resource-name-truncate mb-0">
                    <Link id={`alertlog-link-${item?.id}`}
                          to={`/alert-log/${item.id}`}
                          onMouseEnter={() => handleMouseEnter(item.id)}
                          onMouseLeave={() => handleMouseLeave(item.id)}>
                      {item?.name?.length > 30 ? item?.name?.slice(0,30) + "..." : item?.name}
                    </Link>
                    <Popover isOpen={popoverOpen[item.id] || false}
                            target={`alertlog-link-${item?.id}`} placement="top">
                      <PopoverBody>{item.name}</PopoverBody>
                    </Popover>
                    </h6>
                  </div>
                </Col>
                <Col md="1" className="padding-t-10 text-center d-none d-lg-block">
                  <div className="text-center">
                    <img
                      src={getIntegrationLogo(item.integration_type)}
                      alt={item.integration_type}
                      className="avatar-xs rounded-circle"
                    />
                  </div>
                </Col>
                <Col md="1" className="padding-t-10 text-center d-none d-lg-block">
                  <h6 className="resource-name-truncate mb-0">
                    <Link id={`alertlog-service-${item?.id}`}
                          to={`/temperstack-notifications/${item?.application_service_id}`}
                          onMouseEnter={() => handleMouseEnterService(item.id)}
                          onMouseLeave={() => handleMouseLeaveService(item.id)}
                          className="link-primary">
                      {item.application_service.name?.length > 10 ?item.application_service.name?.slice(0,10) + "..." : item.application_service.name }
                    </Link>
                    <Popover isOpen={popoverOpen2[item.id] || false}
                            target={`alertlog-service-${item?.id}`} placement="top">
                      <PopoverBody>{item.application_service.name}</PopoverBody>
                    </Popover>
                  </h6>
                </Col>
                <Col md="2" className="padding-t-10 text-center d-none d-lg-block">
                <h6
                  id={`alertlog-resource-${item?.id}`}
                  className='resource-name-truncate mb-0'
                  onMouseEnter={() => handleMouseEnterResource(item.id)}
                  onMouseLeave={() => handleMouseLeaveResource(item.id)}
                  >
                  { item.resource_url === "#" || item.resource_url === null ?
                    item.resource_name :
                    <Link to={`${item?.resource_url}`}
                          className="link-primary">
                      {item.resource_name?.length > 15 ? item.resource_name?.slice(0,15) + "..." : item.resource_name}
                    </Link>
                  }
                </h6>
                <Popover isOpen={popoverOpen3[item.id] || false}
                         target={`alertlog-resource-${item?.id}`} placement="top">
                  <PopoverBody>{item.resource_name}</PopoverBody>
                </Popover>

                </Col>
                <Col md="1" className="padding-t-10 text-center d-none d-lg-block">
                  <h6
                  id={`alertlog-metric-${item?.id}`}
                  className='resource-name-truncate mb-0'
                  onMouseEnter={() => handleMouseEnterMetric(item.id)}
                  onMouseLeave={() => handleMouseLeaveMetric(item.id)}
                  >
                  {item.metric_name?.length > 10 ? item.metric_name?.slice(0,10) + "..." : item.metric_name}
                </h6>
                <Popover isOpen={popoverOpen4[item.id] || false}
                         target={`alertlog-metric-${item?.id}`} placement="top">
                  <PopoverBody>{item.metric_name}</PopoverBody>
                </Popover>
                </Col>
                <Col xs="2" md="1" className="padding-t-10 text-center custom-width-status">
                  <Badge
                    className="font-size-11"
                    color={
                      item.status === "Alarm"
                        ? "danger"
                        : item.status === "Ok"
                          ? "success"
                          : "warning"
                    }
                  >
                    {item.status === "Acknowledged" ? "Acked" : item.status === "Ok" ? "Resolved" : item.status}
                  </Badge>
                </Col>
                <Col md="1" className="padding-t-10 d-none d-md-flex justify-content-center" style={{ justifyContent: 'center', display: 'flex' }}>

                  {item.assigned_to?.profile_picture_url ? (
                      <div>
                        <img
                            id={`TooltipTop_${index}`}
                            src={item.assigned_to?.profile_picture_url}
                            alt="Profile"
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              marginBottom: "10px"
                            }}
                        />
                        <UncontrolledTooltip placement="top" target={`TooltipTop_${index}`}>
                          {item.assigned_to?.name}
                        </UncontrolledTooltip>
                      </div>
                  ) : ((item.assigned_to?.name)  ?
                 <div> <InitialsAvatar
                      name={item.assigned_to?.name}
                      id={`TooltipTop_${index}`}
                      userColor={userColors.find( (user) => user.id === item.assigned_to?.id)?.color}
                      dimensions="40px"
                      marginBottom='0'
                  />
                   <UncontrolledTooltip placement="top" target={`TooltipTop_${index}`}>
                     {item.assigned_to?.name}
                   </UncontrolledTooltip>
                 </div>  :
                  <img src={profileImg} alt="default profile" style={{height:"40px", width:"40px"}}/>
                  )}
                </Col>

                <Col xs="4" md="1" className="padding-t-10 text-center custom-width-opened_at">
                  {getLocalDateTime(item.opened_at)}
                </Col>
                <Col md="1" className="padding-t-10 text-center d-none d-lg-block">
                  {getLocalDateTime(item.closed_at)}
                </Col>
              </div>
            </CardBody>
          </CardHeader>
        ))}
      </div>
      <h6 style={{ textAlign: 'right', marginTop: '5px' }}>Showing {resourceCount} of {total_resources} Results</h6>
    </React.Fragment>
  )
}

AlertList.propTypes = {
  t: PropTypes.any,
};

export default withRouter(AlertList);
